module.exports = __webpack_public_path__ + "media/images/emblems/Baettwil-blason-c1dfee6f9913f72d553cac4375da9313.png";